import { TableHeader } from '@/components/ui/table';

export function FrontendIdHeader() {
  return <TableHeader className="text-left align-bottom">ID</TableHeader>;
}
